import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './effect-name.reducer';

export const EffectNameDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const effectNameEntity = useAppSelector(state => state.effectName.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="effectNameDetailsHeading">
          <Translate contentKey="coconApp.effectName.detail.title">EffectName</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{effectNameEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="coconApp.effectName.name">Name</Translate>
            </span>
          </dt>
          <dd>{effectNameEntity.name}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="coconApp.effectName.category">Category</Translate>
            </span>
          </dt>
          <dd>{effectNameEntity.category}</dd>
          <dt>
            <span id="displayOrder">
              <Translate contentKey="coconApp.effectName.displayOrder">Display Order</Translate>
            </span>
          </dt>
          <dd>{effectNameEntity.displayOrder}</dd>
        </dl>
        <Button tag={Link} to="/effect-name" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/effect-name/${effectNameEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default EffectNameDetail;
